import { computed, inject, provide } from 'vue';
import { objectType } from '../_util/type';
export const defaultIconPrefixCls = 'anticon';
export const GlobalFormContextKey = Symbol('GlobalFormContextKey');
export const useProvideGlobalForm = (state) => {
    provide(GlobalFormContextKey, state);
};
export const useInjectGlobalForm = () => {
    return inject(GlobalFormContextKey, { validateMessages: computed(() => undefined) });
};
export const GlobalConfigContextKey = Symbol('GlobalConfigContextKey');
export const configProviderProps = () => ({
    iconPrefixCls: String,
    getTargetContainer: {
        type: Function,
    },
    getPopupContainer: {
        type: Function,
    },
    prefixCls: String,
    getPrefixCls: {
        type: Function,
    },
    renderEmpty: {
        type: Function,
    },
    transformCellText: {
        type: Function,
    },
    csp: objectType(),
    input: objectType(),
    autoInsertSpaceInButton: { type: Boolean, default: undefined },
    locale: objectType(),
    pageHeader: objectType(),
    componentSize: {
        type: String,
    },
    componentDisabled: { type: Boolean, default: undefined },
    direction: {
        type: String,
        default: 'ltr',
    },
    space: objectType(),
    /** Alert common props (antd ≥ 5.7 / 5.14). */
    alert: objectType(),
    /** Breadcrumb common props (antd ≥ 5.6). */
    breadcrumb: objectType(),
    /** Card common props (antd ≥ 5.7). */
    card: objectType(),
    /** Empty common props (antd ≥ 5.7). */
    empty: objectType(),
    /** Avatar common props (antd ≥ 5.7). */
    avatar: objectType(),
    /** Progress common props (antd ≥ 5.10). */
    progress: objectType(),
    virtual: { type: Boolean, default: undefined },
    dropdownMatchSelectWidth: { type: [Number, Boolean], default: undefined },
    /** Prefer this over `dropdownMatchSelectWidth` (antd ≥ 5.5 rename). */
    popupMatchSelectWidth: { type: [Number, Boolean], default: undefined },
    form: objectType(),
    pagination: objectType(),
    /** Transfer common props (antd ≥ 5.7; `selectionsIcon` ≥ 5.14). */
    transfer: objectType(),
    /** Button common props (antd ≥ 5.17 / 5.25). */
    button: objectType(),
    theme: objectType(),
    select: objectType(),
    wave: objectType(),
    /** Flex common props (antd ≥ 5.10). */
    flex: objectType(),
    /** Warning level; `strict: false` softens console output (antd ≥ 5.10). */
    warning: objectType(),
    /** Global variant for data-entry components (antd ≥ 5.19). */
    variant: {
        type: String,
        default: undefined,
    },
});
export const configProviderKey = Symbol('configProvider');
export const defaultConfigProvider = {
    getPrefixCls: (suffixCls, customizePrefixCls) => {
        if (customizePrefixCls)
            return customizePrefixCls;
        return suffixCls ? `ant-${suffixCls}` : 'ant';
    },
    iconPrefixCls: computed(() => defaultIconPrefixCls),
    getPopupContainer: computed(() => () => document.body),
    direction: computed(() => 'ltr'),
};
export const useConfigContextInject = () => {
    return inject(configProviderKey, defaultConfigProvider);
};
export const useConfigContextProvider = (props) => {
    return provide(configProviderKey, props);
};
